import Marionette from "../../shared/marionette-mustache";
import { FileStatusView } from "./file-status";
import { FileStatusModel } from "../models/file-status";
import { backboneViewProperties } from "../../decorators/backbone-properties";

@backboneViewProperties({
    tagName: "ul",
    className: "file-status-list",
    childView : FileStatusView
})
export class FileStatuses extends Marionette.CollectionView<FileStatusModel, FileStatusView> {
    constructor(options?: Marionette.CollectionViewOptions<FileStatusModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/import-status/views/file-statuses.ts